import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppLockSessionComponent } from '../../shared/app-lock-session/app-lock-session.component';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import {ApiService} from '../../services/api.service';
import {loaderConfig} from '../../config/loader';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ValidatorsService} from '../../services/validators/validators.service';
import { Location } from '@angular/common';


@Component({
  selector: 'app-reject',
  templateUrl: './reject.component.html',
  styleUrls: ['./reject.component.css']
})
export class RejectComponent implements OnInit {

  /**
   * Session hash
   */
  private hash: string;

  /**
   * Param hash
   */
  private param_hash: string;

  /**
   * checksesInterval
   */
  private checksesInterval: any;

  /**
   * modal that lock a session
   */
  @ViewChild('lockSession') private lockSession: AppLockSessionComponent;

  /**
   * Indicate role of logged user (0: Gestor Flota, 1: Conductor)
   */
  public rolAcceso: number;

  /**
   * Indicate role who has permission to opperate fine (0: Gestor Flota, 1: Conductor)
   */
  public rolPermiso: number;

  /**
   * Indicate state of enlace (1: enviado, 2: pagado, 3: identificado, 4: compartido)
   */
  public acceso: number;

  /**
   * Fine data
   */
  public finedata: any;

  loading = false;
  error = false;
  success = false;
  showView = false;
  public loaderOptions: any = loaderConfig;
  public timeOut =  false;
  public diffDays: number;
  public diffHrs: number;
  public diffMins: number;
  public files = [];

  rejectionForm: FormGroup = this.formBuilder.group({
    reason: ['', [Validators.required] ]
  });

  public submitted = false;

  constructor(private router: Router,
              private translate: TranslateService,
              private route: ActivatedRoute,
              private authService: AuthService,
              private http: HttpClient,
              private apiService: ApiService,
              private ngxLoader: NgxUiLoaderService,
              private formBuilder: FormBuilder,
              private vs: ValidatorsService,
              private location: Location) {

    this.hash = this.authService.getHash();

    this.route.params.subscribe(params => {
      this.param_hash = params['hash'];
    });
  }

  ngOnInit() {
    this.ngxLoader.start();
    this.files = JSON.parse(localStorage.getItem('expedientes'));
    // if session hash is different from hash of route eject from session to login page.
    if (this.hash !== this.param_hash) {
      this.lockSession.open();
      return false;
    }

    this.checksesInterval = setInterval(() => {
      this.hash = this.authService.getHash();
      if (this.hash !== this.param_hash) {
        this.lockSession.open();
        clearInterval(this.checksesInterval);
        return false;
      }

    }, 1000 * 60);

    this.apiService.getFineData(`${this.hash}`,`${this.files[0]}`)
        .subscribe((response: any) => {
          this.finedata = response;
          this.acceso = this.finedata.acceso;
          this.rolAcceso = this.finedata.rolAcceso;
          this.rolPermiso = this.finedata.rolPermiso;
          const fechaHoraServidor = this.finedata.fechaHoraServidor.date;
          const fechaFinEnlace = this.finedata.fechaFinEnlace.date;
          const dateExpires = new Date(fechaFinEnlace.replace(' ', 'T'));
          const nowdate = new Date(fechaHoraServidor.replace(' ', 'T'));
          if (nowdate.getTime() > dateExpires.getTime()) {
            this.timeOut = true;
          } else {
            const diffMs = Math.abs(dateExpires.getTime() - nowdate.getTime() );
            this.diffDays = Math.floor(diffMs / 86400000);
            this.diffHrs = Math.floor((diffMs % 86400000) / 3600000);
            this.diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
          }
          this.ngxLoader.stop();
          this.ejectFromRoute();
        });
  }

  viewFine() {
    this.location.back();
  }

  /**
   * POST Call that is used to share the fine to a given driver
   * Url endpoint example: this.apiService.rejectFine(`/payyourfines/rechazar/${ this.hash }`)
   */
  rejectFine(motivo: string) {
    const datos = {'expedientes': this.files, 'motivo': motivo};
    this.loading = true;
    this.error = false;
    this.success = false;
    const URL_API = environment.URL_API;
    const url = URL_API + 'rechazar/' + this.authService.getHash();
    const headers: HttpHeaders = new HttpHeaders().set('TOKEN', this.authService.getToken());
    return this.http.post<any>(url, datos, {headers}).subscribe(
        data => {
          setTimeout(() => {
            this.loading = false;
            Swal.fire({
              title: this.translate.instant('AppLockSession.rejecting.header'),
              text: this.translate.instant('AppLockSession.rejecting.body'),
              confirmButtonColor: '#585D6A',
              confirmButtonText: '<i class="fa fa-chevron-right"></i> ' + this.translate.instant('AppLockSession.rejecting.button'),
              allowOutsideClick: false,
              allowEscapeKey: false,
              type: 'success'
            }).then((result) => {
              if (result.value) {
                this.authService.logout();
                this.router.navigate([`/app/login/pyf/${this.hash}`]);
              }
            });
          }, 1500);
        },
        error => {
          this.error = true;
          this.success = false;
          this.loading = false;
        }
    );
  }

  ejectFromRoute() {
    let allowed = false;
    if (this.timeOut) {
      allowed = false;
    } else {
      if (this.acceso === 1) {
        if (this.rolAcceso === this.rolPermiso) {
          allowed = true;
        }
      } else {
        if ((this.rolAcceso === 1 || this.rolAcceso === 2) && this.acceso === 4) {
          allowed = true;
        }
      }
    }
    if (!allowed || this.rolAcceso !== 1) {
      this.viewFine();
    } else {
      this.showView = true;
    }
  }

  get form() {
    return this.rejectionForm.controls;
  }
  fieldIsValid(campo: string) {
    return this.rejectionForm.controls[campo].errors && this.rejectionForm.controls[campo].touched;
  }

  get reasonErrorMsg(): string {
    const errors = this.rejectionForm.get('reason').errors;
    let msg = '';
    if ( errors.required ) {
      msg = this.translate.instant('RejectionPage.FieldError');
      return msg;
    }
    return msg;
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    if ( this.rejectionForm.invalid ) {
      this.markFormGroupTouched(this.rejectionForm);
      return;
    }
    this.submitted = true;
    const DATAFORM = {
      'motivo': this.rejectionForm.value.reason
    };
    this.rejectFine(DATAFORM['motivo']);

  }

}
